import { fromJS, Record } from 'immutable';

export const projectsRecord = new Record({
  activeProjectId: null,
  allIds: fromJS([]),
  allProjects: fromJS([]),
  byId: fromJS({}),
  colors: fromJS([])
});

export default projectsRecord();
